import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { Button } from 'src/components';
import DeleteInformationModal from 'src/components/DeleteInformation/DeleteInformationModal';
import { useDeleteDocumentFileUploadMutation } from 'src/rtk/features/setup/documentFileUpload/documentFileUploadApi';

interface Props {
  documentFileUpload: DocumentFileUpload;
  index: number;
}

const DocumentFileUploadTableRow = ({ documentFileUpload, index }: Props) => {
  const history = useHistory();
  const [deleteDocumentFileUpload, { isSuccess, isLoading, isError }] =
    useDeleteDocumentFileUploadMutation();
    
  const [infoId, setInfoId] = useState('');
  const [modalShow, setModalShow] = useState(false);

  const deleteHandler = (modalState: boolean, id: string) => {
    setModalShow(modalState);
    setInfoId(id);
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success('Document File Upload deleted successfully');
    }
    if (isError) {
      toast.error('Error deleting Document File Upload');
    }
  }, [isSuccess, isError]);

  return (
    <tr key={documentFileUpload.id}>
      <th scope="row">{index + 1}</th>
      <td>{documentFileUpload.document_name}</td>
      <td>{documentFileUpload.document_for}</td>
      <td>{documentFileUpload.document_type}</td>
      <td>{documentFileUpload.file_type}</td>
      <td>{documentFileUpload.file_size}</td>
      <td>{documentFileUpload.file_size_unit}</td>
      <td>{documentFileUpload.status ? 'Active' : 'Inactive'}</td>
      <td>
        <div className="d-flex gap-2">
          <Button
            size="sm"
            text="Edit"
            color="warning"
            onClick={() =>
              history.push(`/setup/document-file-upload/update/${documentFileUpload.id}`)
            }
          />

          <Button
            size="sm"
            text="Delete"
            color="danger"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={() => deleteHandler(true, documentFileUpload.id!)}
          />
        </div>
        {modalShow ? (
          <DeleteInformationModal
            isOpen={modalShow}
            toggle={() => setModalShow(!modalShow)}
            id={infoId}
            deleteInfomation={deleteDocumentFileUpload}
          />
        ) : null}
      </td>
    </tr>
  );
};

export default DocumentFileUploadTableRow;
